import { createGlobalStyle } from "styled-components";
import GilroyBold from "../assets/fonts/Gilroy-Bold.ttf";
import GilroySemiBold from "../assets/fonts/Gilroy-SemiBold.ttf";
import GilroyRegular from "../assets/fonts/Gilroy-Regular.ttf";

export const FontsImport = createGlobalStyle`
  /* Fonte da marca com pesos reais: e o que var(--font-sans) usa (redesign V3, fase 1). */
  @font-face {
    font-family: 'Gilroy';
    src: url(${GilroyRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Gilroy';
    src: url(${GilroySemiBold}) format('truetype');
    font-weight: 500 600;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Gilroy';
    src: url(${GilroyBold}) format('truetype');
    font-weight: 700 900;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'gilroyBold';
    src: url(${GilroyBold}) format('truetype');
    font-style: normal;
  }
    @font-face {
    font-family: 'gilroyRegular';
    src: url(${GilroyRegular}) format('truetype');
    font-style: normal;
  }
    @font-face {
    font-family: 'gilroySemiBold';
    src: url(${GilroySemiBold}) format('truetype');
    font-style: normal;
  }
`;
export const fonts = {
  gilroyBold: "gilroyBold",
  gilroyRegular: "gilroyRegular",
  gilroySemiBold: "gilroySemiBold",
};

export const fontSize = {
  xsm: "13px",
  sm: "0.475em",
  mm: "0.875em",
  md: "1.25em",
  md2: "1.625em",
  lg: "2.1875em",
  xlg: "2.625em",
  xxlg: "3.75em",
  base: "12px",
};

export const devices = {
  mobileS: `(max-width: 320px)`,
  mobileM: `(max-width: 375px)`,
  mobileL: `(max-width: 425px)`,
  mobileXL: `(max-width: 430px)`,
  tablet: `(max-width: 1023px)`,
  laptop: `(min-width: 1024px)`,
  laptopL: `(max-width: 1440px)`,
  laptopS: `(max-width: 1470px)`,
  desktop: `(max-width: 2560px)`,
};
export const colors = {
  blue: {
    primary: "#1264C7",
  },
  brown: {
    capivara: "#c6a25c",
    primary: "#231f20",
    primaryDisabled: "#6b6768",
    secundary: "#fefcf8",
    capivaraLight: "#e9bb6d",
    capivaraLightAux: "#f7e7cc",
  },
  palete: {
    brownDark: "#231f20",
    brownLight: "#42372b",
    brownLighter: "#f9ebd4",
    brownExtraLighter: "#fdf8f0",
    gold: "#C6A25C",
    tableOdd: "#F2ECE2",
    green: "#008000",
    greenHover: "#007300",
    red: "#B85242",
    redHover: "#9C4638",
  },
};
/** Tokens do redesign V3 (os mesmos de src/index.css). Para codigo novo; o antigo usa os hex direto. */
export const tokens = {
  brand: "#1264C7",
  brand700: "#0B4FA8",
  brand50: "#EAF1FB",
  brand100: "#D6E4F7",
  bg: "#F7F9FC",
  line: "#E2E6EA",
  ink: "#1F1F1F",
  text: "#2B2D31",
  textMuted: "#5F6368",
  success: "#1E8E3E",
  successBg: "#EAF7EE",
  warn: "#F9AB00",
  warnBg: "#FFF7E0",
  error: "#D93025",
  errorBg: "#FCE8E6",
  radiusButton: "12px",
  radiusCard: "16px",
  fontSans: '"Gilroy", "Roboto", Arial, sans-serif',
};

export default {
  fontSize,
  devices,
  colors,
  fonts,
  tokens,
};
